import { ref, reactive, computed, toRef, watch } from 'vue'
import { defineStore } from 'pinia'
import utils from '@/utils/utils'
import { useDdClient } from '@/stores/due_diligence/ddClient.store'
import { useDdEstate } from '@/stores/due_diligence/ddEstate.store'

export const useDdDeal = defineStore('ddDeal', () => {

  const model = reactive({})
  const ddClient = useDdClient()
  const ddEstate = useDdEstate()
  const { grandTotals: clientTotals } = ddClient
  const { grandTotals: estateTotals } = ddEstate

  //               :id => :integer,
  //          :deal_id => :integer,
  //           :status => :integer,
  //       :assignment => :money,
  //          :advance => :money,
  //    :dd_officer_id => :integer,
  //       :created_at => :datetime,
  //       :updated_at => :datetime

  function loadData(responseData) {
    // To update the object's properties while preserving reactivity:
    Object.assign(model, responseData)
    // console.log('dealDD.loadData', model)
  }


  const grandTotals = {
    atvTotalAssignments: ref(0),
    atvRate: computed(() => {
      const c1 = grandTotals.atvTotalAssignments.value
      const c2 = clientTotals.remainingShareToDist
      if (c1 && c2) {
        return 100.0 * (c1 / c2)
      } else {
        return undefined
      }
    }),
    atvAllowableDrop: computed(() => {
      const c1 = grandTotals.atvTotalAssignments.value
      const c2 = clientTotals.remainingShareToDist
      if (!c1 || !c2) {
        return null
      } else {
        const diff = c1 - c2
        const rate = clientTotals.shareRate || 100.0
        return -1 * diff / (rate/100.0)
      }
    }),
    atvAllowableDropRate: computed(() => {
      const c1 = estateTotals.realEstate
      const c2 = grandTotals.atvAllowableDrop.value
      if (!c1 || !c2) return null
      return 100.0 * c2 / c1
    }),
    atvAllowableDropDiff: computed(() => {
      const c1 = estateTotals.realEstate
      const c2 = grandTotals.atvAllowableDrop.value
      if (!c1 || !c2) return null
      return c1 - c2
    }),
  }

  // The ATV Subtotal is the sum of all estate deal assignments
  // and is set in the AtvAssignments component
  function setTotalAssignments(val) {
    grandTotals.atvTotalAssignments.value = val
  }

  return {
    // raw data refs
    model,
    // helper methods
    loadData,
    // computed calculations
    // calcs,
    grandTotals,
    setTotalAssignments,
  }
}, { persist: false }) // Do not persist in localStorage
